export const getDownloadUrl = async (/** @type {string} */ url, /** @type {string} */ accessToken) => {
  const response = await fetch(url, {
    headers: {
      'Authorization': `Bearer ${accessToken}`
    }
  });
    
  if (response.status !== 200)
    throw Error('Error retreiving document');

  const documentBlob = await response.blob();

  if (documentBlob.type !== 'application/pdf')
    throw Error('Error retreiving document!');

  return URL.createObjectURL(documentBlob);
};